/**
 * return calculate unitCost, supplyCost, tax
 * @example (1000000, 1) to {unitCost: 909091, supplyCost: 909091, tax: 90909}
 * @example (1000000, 2) to {unitCost: 454545, supplyCost: 909090, tax: 90910}
 * @example (1000000, 3) to {unitCost: 303030, supplyCost: 909090, tax: 90910}
 * @example (1000000, 4) to {unitCost: 227273, supplyCost: 909092, tax: 90908}
 * @param totalAmount
 * @param quantity
 */
export const calcAmountsFromTotalAmount: (totalAmount: number, quantity: number) => {
  unitCost: number,
  supplyCost: number,
  tax: number,
}
  = (totalAmount, quantity) => {
  // 총 금액이 정수로 나누어 떨어지지 않을 경우 나머지 금액(remainder)은 세액에 더한다.
  const amount = Math.floor(totalAmount / quantity)
  const remainder = totalAmount - (amount * quantity)
  const unitCost = Math.round(amount / 11 * 10)
  const unitTax = amount - unitCost
  const supplyCost = unitCost * quantity
  const tax = unitTax * quantity + remainder
  return {
    unitCost,
    supplyCost,
    tax,
  }
}


/**
 * return calculate supplyCost, tax, totalAmount
 * @example (1000000, 1) to {supplyCost: 1000000, tax: 100000, totalAmount: 1100000}
 * @example (1000000, 2) to {supplyCost: 2000000, tax: 200000, totalAmount: 2200000}
 * @example (1000000, 3) to {supplyCost: 3000000, tax: 300000, totalAmount: 3300000}
 * @example (1000000, 4) to {supplyCost: 4000000, tax: 400000, totalAmount: 4400000}
 * @param unitCost
 * @param quantity
 * @param taxFree
 */
export const calcAmountsFromUnitCost: (unitCost: number, quantity: number, taxFree: boolean) => {
  supplyCost: number,
  tax: number,
  totalAmount: number,
}
  = (unitCost, quantity, taxFree) => {
  const supplyCost = Math.floor(unitCost * quantity)
  const tax = taxFree ? 0 : calcTaxationTaxFromSupplyCost(supplyCost)
  const totalAmount = supplyCost + tax
  return {
    supplyCost,
    tax,
    totalAmount,
  }
}

/**
 * return calculate supplyCost, tax, totalAmount
 * @example (1000000, 1) to {supplyCost: 1000000, tax: 100000, totalAmount: 1100000}
 * @example (1000000, 2) to {supplyCost: 2000000, tax: 200000, totalAmount: 2200000}
 * @example (1000000, 3) to {supplyCost: 3000000, tax: 300000, totalAmount: 3300000}
 * @example (1000000, 4) to {supplyCost: 4000000, tax: 400000, totalAmount: 4400000}
 * @param unitCost
 * @param quantity
 * @param customTax (customTax)
 */
export const calcAmountsFromUnitCostAndTax:
  (unitCost: number, quantity: number, customTax: number) => {
  supplyCost: number,
  tax: number,
  totalAmount: number,
}
  = (unitCost, quantity, customTax) => {
  const supplyCost = Math.floor(unitCost * quantity)
  const tax = customTax
  const totalAmount = supplyCost + tax
  return {
    supplyCost,
    tax,
    totalAmount,
  }
}


/**
 * return default taxation tax amount
 * @example 10000 to 11000
 * @param supplyCost
 */
export const calcTaxationTaxFromSupplyCost: (number) => number = (supplyCost) => {
  return Math.floor(supplyCost * 0.1)
}
